import { Button, MenuProps } from "antd";

export interface DropdownItem {
  label: React.ReactNode;
  icon: React.ReactNode;
  action: () => void;
}

export const getExportFolderDropdownItems = (elements: DropdownItem[]) => {
  const items: MenuProps["items"] = elements.map((element, index) => {
    return {
      key: index,
      label: (
        <Button
          type="link"
          className="w-full p-0 text-left flex items-center text-gray-900"
          icon={element.icon}
          onClick={element.action}
        >
          {element.label}
        </Button>
      ),
    };
  });

  return items;
};
